import React, { useState, useEffect } from 'react';
import { FaArrowLeft, FaPen, FaRedo, FaCheck, FaTimes } from 'react-icons/fa';
import { FaMagic } from 'react-icons/fa';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { Box, Checkbox, FormControl,Button , FormHelperText, InputLabel, MenuItem, Select, TextField, Grid, Typography } from '@mui/material';
import img from '../../../../../../assets/Heygen/img1.jpg'
import { New_Project_Button_bg_color } from '../../../../../../Provider/Color_Provider';
import { button_bg_color_for_New_Project } from '../../../../../../constants/colors';
import EEP1Img from '../../../../../../assets/Heygen/EEP1.png'
import EEP2Img from '../../../../../../assets/Heygen/EEP2.png'
import EEP3Img from '../../../../../../assets/Heygen/EEP3.png'
import EEP4Img from '../../../../../../assets/Heygen/EEP4.png'
import EEP5Img from '../../../../../../assets/Heygen/EEP5.png'
import EEP6Img from '../../../../../../assets/Heygen/EEP6.png'
import EEP7Img from '../../../../../../assets/Heygen/EEP7.png'
import EEP8Img from '../../../../../../assets/Heygen/EEP8.png'
import EEP9Img from '../../../../../../assets/Heygen/EEP9.png'
import EEP10Img from '../../../../../../assets/Heygen/EEP21.png'
import { createAvatarGroup, generateAvatarPhotos, pollGenerationStatus } from '../../../../../../contexts/WorkspaceUtils';
import { useWorkspace } from "../../../../../../contexts/WorkspaceContext";
import { CommanLoaderForAvatarGeneration } from '../../../../../Common_Components/Comman_Loader';


const CreateAvatarFromScript = ({ onClose }) => {
  const [currentView, setCurrentView] = useState('main'); // 'main', 'loading', 'preview', 'prompts'
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedPrompt, setSelectedPrompt] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
const [generationError, setGenerationError] = useState(null);
const [generationId, setGenerationId] = useState(null);
const [isSaving, setIsSaving] = useState(false);
const [error, setError] = useState(null);
const [statusData, setStatusData] = useState(null);
const {showAvatarCreation,setShowAvatarCreation,setIsModalOpenForAvatarGenerationOption} = useWorkspace();
  const [formData, setFormData] = useState({
  name: '',
  age: 'Unspecified',
  gender: 'Unspecified',
  ethnicity: 'Unspecified', // Must be one of the valid options
  description: '',
  orientation: 'square',
  pose: 'Half body',
  style: 'Unspecified'
});
    const theme = localStorage.getItem("theme");
    const [lastIndex, setLastIndex] = useState(-1);

  // Mock images for preview
  const [previewImages, setPreviewImages] = useState([
  { id: 1, url: img },
  { id: 2, url: img },
  { id: 3, url: img },
  { id: 4, url: img }
]);

    const customTextFieldStyles = (isInvalid) => {
    return {
      "& .MuiInputLabel-root": {
        fontFamily: "Inter",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px",
        letterSpacing: "0.5px",
        color: "rgba(255, 255, 255, 0.80)",
        "&.Mui-focused": {
          color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80)",
        },
      },
      "& .MuiInputBase-input": {
        color: "#FFFFFF",
      },
      "& #outlined-basic-label": {
        color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80)",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: isInvalid ? "#F2B8B5" : "rgba(255, 255, 255, 0.80)",
        },
        "&:hover fieldset": {
          borderColor: isInvalid ? "#F2B8B5" : "rgba(255, 255, 255, 0.80)",
        },
        "&.Mui-focused fieldset": {
          borderColor: isInvalid
            ? "#F2B8B5 !important"
            : "rgba(255, 255, 255, 0.80) ",
        },
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root": {
        color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80) ",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: isInvalid
          ? "#F2B8B5 !important"
          : "rgba(255, 255, 255, 0.80) ",
      },
    };
  };

   const customTextFieldStylesForInvalid = () => {
    return {
      "& .MuiInputLabel-root": {
        fontFamily: "Inter",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px",
        letterSpacing: "0.5px",
        color: "rgba(255, 255, 255, 0.80)",
        "&.Mui-focused": {
          color: "rgba(255, 255, 255, 0.80)",
        },
      },
      "& .MuiInputBase-input": {
        color: "#FFFFFF",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "rgba(255, 255, 255, 0.80)",
        },
        "&:hover fieldset": {
          borderColor: "rgba(255, 255, 255, 0.80)",
        },
        "&.Mui-focused fieldset": {
          borderColor: "rgba(255, 255, 255, 0.80) ",
        },
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root": {
        color: "rgba(255, 255, 255, 0.80) ",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgba(255, 255, 255, 0.80) ",
      },
    };
  };

     const customTextFieldStylesforDropDownButton = {
    "& .MuiInputLabel-root": {
      fontFamily: "Inter",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "24px",
      letterSpacing: "0.5px",
      color: "rgba(255, 255, 255, 0.80)",
      "&.Mui-focused": {
        color: "rgba(255, 255, 255, 0.80) !important",
      },
    },
    "& .MuiInputBase-input": {
      color: "#FFFFFF",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "rgba(255, 255, 255, 0.80)",
      },
      "&:hover fieldset": {
        borderColor: "rgba(255, 255, 255, 0.80)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "rgba(255, 255, 255, 0.80) !important",
      },
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root": {
      color: "rgba(255, 255, 255, 0.80) !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(255, 255, 255, 0.80) !important",
    },
  };

  // Mock prompt examples
  const promptExamples = Array(10).fill().map((_, i) => (
    {
    id: i + 1,
    url: EEP1Img,
    text: `Example Prompt ${i + 1}`
    }
));
  const promptExamples2 = [
    {
    id: 1,
    url: EEP1Img,
    text: `A futuristic studio with LED panels in blue and purple, two microphones on adjustable stands, and a host wearing over-ear headphones while typing on a laptop, looking at the camera`
    },
    {
    id: 2,
    url: EEP2Img,
    text: `A 22-year-old Black woman with flawless skin, sitting at a vanity with a ring light softly illuminating her face. She leans close to the phone camera. Behind her, a neatly organized shelf of makeup products and warm fairy lights create a cozy, professional atmosphere.`
    },
    {
    id: 3,
    url: EEP3Img,
    text: `A 24-year-old White woman in a trendy streetwear outfit, sitting on the steps of a vibrant urban street. She talks to the camera about styling tips, with colorful graffiti and bustling pedestrians providing a dynamic and lively backdrop.`
    },
    {
    id: 4,
    url: EEP4Img,
    text: `A 32-year-old Middle Eastern woman sitting at a rustic wooden table in a cozy kitchen. She speaks directly to the phone camera about her favorite dessert recipe, with a beautifully plated cake in the foreground and shelves filled with spices and ingredients in the background.`
    },
    {
    id: 5,
    url: EEP5Img,
    text: `A 28-year-old blonde woman in a vibrant athleisure set, standing on a yoga mat in a brightly lit studio. She speaks enthusiastically towards the camera about a quick 10-minute workout routine, with dumbbells and resistance bands neatly arranged in the background. Large windows let in soft natural light, creating a calm yet energetic setting.`
    },
     {
    id: 6,
    url: EEP6Img,
    text: `A 30-year-old White man in a bright, modern kitchen, gesturing as he shares a quick recipe. He stands near a polished marble countertop with neatly arranged fresh fruits, vegetables, and a blender behind him. Shelves with stylish jars and utensils add warmth to the vibrant setting.`
    },
     {
    id: 7,
    url: EEP7Img,
    text: `A 25-year-old Black woman wearing a pastel pink sweatshirt, seated on a cozy beige couch with natural light streaming through large windows. She leans slightly forward, animatedly explaining the benefits of a skincare routine, with neatly arranged skincare products on a coffee table in the foreground and houseplants adding a fresh vibe to the background.`
    },
     {
    id: 8,
    url: EEP8Img,
    text: `A 28-year-old male journalist in a tailored blazer, standing on a busy city street holding a microphone. He speaks directly to the camera, delivering breaking news with a serious demeanor. Behind him, pedestrians bustle through the street, and a cameraman and news van are visible, adding to the dynamic, on-the-ground setting.`
    },
     {
    id: 9,
    url: EEP9Img,
    text: `A 40-year-old news host in a sharp navy suit and tie, standing in a sleek, modern newsroom. The backdrop features large screens displaying live news feeds and a scrolling ticker with headlines.`
    },
     {
    id: 10,
    url: EEP10Img,
    text: `A woman taking selfie in front of large mirror, holding her smartphone in one hand. She poses slightly to the side to highlight her outfit and accessories. She stands in a dressing, with soft lighting creating a warm and inviting atmosphere.`
    }
    
  ]

  const sampleScript = [
    {id:1, text : `A tech-savvy hispanic man in a futuristic lab with glowing screens. `},
    {id:2, text : `A friendly hispanic woman in a cozy classroom holding a book. `},
    {id:3, text : `A confident hispanic man in a tailored suit standing in a modern office. `},
    {id:4, text : `A beautiful fit hispanic woman in workout clothes on a rooftop gym at sunrise. `},
    {id:5, text : `A friendly hispanic woman in a cozy classroom holding a book. `},
    {id:6, text : `A cheerful hispanic man in a professional kitchen holding a freshly plated dish. `},
    {id:7, text : `A young hispanic man in hiking gear standing on a mountain trail. `},
    {id:8, text : `A fit hispanic woman with blonde hair standing outside in front of two cars with a grey sports bra and silver necklace on. `},
    {id:9, text : `An old hispanic man wearing a sweater vest sitting in a chair with a book in his hand. Outside on the patio. `},
    {id:10, text : `A friendly hispanic woman in a cozy classroom holding a book. `},
    {id:11, text : `A beautiful fit hispanic woman in workout clothes on a rooftop gym at sunrise. `},
    {id:12, text : `A fit hispanic man with two tattoos on his arm. He is wearing a pink tank top. He is sitting on a bed. He has a light subtle beard with a fade haircut. `},
    {id:13, text : `A hispanic man in a high-tech setup surrounded by colorful LED lights. `},
    {id:14, text : `A fit hispanic woman with blonde hair standing outside in front of two cars with a grey sports bra and silver necklace on. `},
    {id:15, text : `A creative hispanic man in a paint-splattered apron working in a sunlit studio. `},
  ]

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

const handleGeneratePreview = async () => {
  setIsGenerating(true);
  setGenerationError(null);
  setCurrentView('loading');

  try {
    // Transform parameters to match API expectations
    const apiParams = {
      name: formData.name,
      age: formData.age,
      gender: formData.gender,
      ethnicity: formData.ethnicity,
      orientation: formData.orientation.toLowerCase(),
      pose: formData.pose.toLowerCase().replace(' ', '_'),
      style: formData.style,
      appearance: formData.description
    };

    // Step 1: Start generation
    const generationResponse = await generateAvatarPhotos(apiParams);
    const generationId = generationResponse.data?.data?.generation_id;
    
    if (!generationId) {
      throw new Error('Failed to get generation ID from response');
    }
    
    setGenerationId(generationId);
    
    // Step 2: Poll for generation status
    const statusData = await pollGenerationStatus(generationId);
    setStatusData(statusData);
    
    // Verify we have the image URLs
    if (!statusData.image_url_list || statusData.image_url_list.length === 0) {
      throw new Error('No images were generated');
    }
    
    // Step 3: Update state with generated images
    setPreviewImages(statusData.image_url_list.map((url, index) => ({
      id: index + 1,  // Using index + 1 as ID (1, 2, 3, 4)
      url: url
    })));
    
    // Reset selection when new images are generated
    setSelectedImage(null);
    
    setIsGenerating(false);
    setCurrentView('preview');
    
  } catch (error) {
    console.error('Failed to generate avatar preview:', error);
    setGenerationError(error.message || 'Failed to generate preview. Please try again.');
    setIsGenerating(false);
    setCurrentView('main');
  }
};
  const handleExplorePrompts = () => {
    setCurrentView('prompts');
  };

  const handleUsePrompt = (prompt) => {
    setSelectedPrompt(prompt);
    setFormData(prev => ({ ...prev, description: prompt.text }));
    setCurrentView('main');
  };

const handleSaveAvatar = async () => {
  if (!selectedImage) return;

  setIsSaving(true);
  setError(null);

  try {
    // Find the selected image from previewImages
    const selectedAvatar = previewImages.find(img => img.id === selectedImage);
    
    if (!selectedAvatar) {
      throw new Error('Selected image not found');
    }

    // Extract the image key by matching the URL with image_key_list
    // First, get the filename part from the URL
    const urlParts = selectedAvatar.url.split('/');
    const filename = urlParts[urlParts.length - 1]; // e.g. "1.jpg"
    
    // Then find the matching image_key from the statusData we stored earlier
    // Note: You'll need to store the statusData from pollGenerationStatus in state
    const matchingKey = statusData.image_key_list.find(key => 
      key.endsWith(filename)
    );
    
    if (!matchingKey) {
      throw new Error('Could not find matching image key');
    }

    // Call the API to create the avatar group
    const response = await createAvatarGroup(matchingKey, formData.name);
    
    console.log('Avatar group created:', response);
    
    // Close the modal
    onClose();
    setShowAvatarCreation(false);
    setIsModalOpenForAvatarGenerationOption(false);
  } catch (err) {
    console.error('Failed to save avatar:', err);
    setError('Failed to save avatar. Please try again.');
  } finally {
    setIsSaving(false);
  }
};

const handleRandomDescription = () => {
  let randomIndex;
  do {
    randomIndex = Math.floor(Math.random() * sampleScript.length);
  } while (randomIndex === lastIndex && sampleScript.length > 1); // Avoid infinite loop if array has only 1 item
  
  setLastIndex(randomIndex);
  setFormData({ ...formData, description: sampleScript[randomIndex].text });
};

  const renderMainView = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px'}}>
      {/* Title with Explore button */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{
          color: '#FFF',
          fontFamily: 'Inter',
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: '600',
          lineHeight: '20px',
          alignSelf: 'stretch'
        }}>
          Describe your avatar's look
        </div>
        <button 
          onClick={handleExplorePrompts}
          style={{
            display: 'flex',
            padding: '10px 12px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
            alignSelf: 'stretch',
            borderRadius: '4px',
            background: 'white',
            border: 'none',
            cursor: 'pointer'
          }}
        >
           <AutoFixHighIcon sx={{width:"18px", height:"18px", color: '#17182C',}}/>
          <span style={{
            color: '#17182C',
            textAlign: 'center',
            fontFamily: 'Inter',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: '600',
            lineHeight: '20px',
            letterSpacing: '0.1px'
          }}>
            Explore example prompts
          </span>
        </button>
      </div>

      {/* Form fields */}
      {/* Name and Age Row */}
      {/* <div style={{ display: 'flex', gap: '16px' }}>
        <div style={{ flex: 1 }}>
          <input
            type="text"
            name="name"
            placeholder="What do you want to name your avatar?"
            value={formData.name}
            onChange={(e)=>handleInputChange(e)}
            style={{
              width: '100%',
              padding: '12px 16px',
              borderRadius: '4px',
              background: 'rgba(255, 255, 255, 0.1)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              color: 'white',
              fontSize: '14px'
            }}
          />
        </div>
        <div style={{ flex: 1 }}>
          <input
            type="text"
            name="age"
            placeholder="Young adult"
            value={formData.age}
            onChange={(e)=>handleInputChange(e)}
            style={{
              width: '100%',
              padding: '12px 16px',
              borderRadius: '4px',
              background: 'rgba(255, 255, 255, 0.1)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              color: 'white',
              fontSize: '14px'
            }}
          />
        </div>
      </div> */}


      <Box
  sx={{
    display: 'flex',
    gap: 2,        // MUI spacing scale – equals 16px by default
    width: '100%',
    mb: 2,
  }}
>
  <TextField
    type="text"
    name="name"
    label="Name*"
    placeholder="What do you want to name your avatar?"
    value={formData.name}
    onChange={(e)=>handleInputChange(e)}
    variant="outlined"
    id="outlined-basic"
    sx={[
      customTextFieldStyles(false),
      {
        flex: 1,             // takes up equal share
        maxHeight: 56,
        fontSize: 14,
      },
    ]}
  />

  <Box sx={{ minWidth: "49%", marginBottom: 3 }}>
  <FormControl fullWidth>
    <InputLabel
      id="age-select-label"
      sx={{
        color: "rgba(255, 255, 255, 0.80)",
        "&.Mui-focused": {
          color: "rgba(255, 255, 255, 0.80) !important",
        },
      }}
    >
      Age*
    </InputLabel>
    <Select
      name="age"
      labelId="age-select-label"
      id="age-select"
      value={formData.age}
      label="Age"
      onChange={handleInputChange}
      sx={{
        ...customTextFieldStylesforDropDownButton,
        "& .MuiSelect-select": {
          backgroundColor: "#282D51",
        },
        ".MuiSelect-icon": {
          color: "#ffffff",
        },
      }}
    >
      {['Young Adult', 'Early Middle Age', 'Late Middle Age', 'Senior', 'Unspecified'].map((age) => (
        <MenuItem
          key={age}
          value={age}
          sx={{
            bgcolor: "#2F355F",
            marginTop: "-8px",
            marginBottom: "-8px",
            color: "white",
            height: "56px",
            "&:hover": {
              bgcolor: "#393F69",
            },
            "&.Mui-selected": {
              bgcolor: "#393F69 !important",
            },
          }}
        >
          {age}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Box>
</Box>


      {/* Gender and Ethnicity Row */}
      <div style={{ display: 'flex', gap: '16px' }}>
        {/* <div style={{ flex: 1 }}>
          <select
            name="gender"
            value={formData.gender}
            onChange={handleInputChange}
            style={{
              width: '100%',
              padding: '12px 16px',
              borderRadius: '4px',
              background: 'rgba(255, 255, 255, 0.1)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              color: 'white',
              fontSize: '14px'
            }}
          >
            <option value="Unspecified">Unspecified</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div style={{ flex: 1 }}>
          <select
            name="ethnicity"
            value={formData.ethnicity}
            onChange={handleInputChange}
            style={{
              width: '100%',
              padding: '12px 16px',
              borderRadius: '4px',
              background: 'rgba(255, 255, 255, 0.1)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              color: 'white',
              fontSize: '14px'
            }}
          >
            <option value="Unspecified">Unspecified</option>
            <option value="Caucasian">Caucasian</option>
            <option value="African">African</option>
            <option value="Asian">Asian</option>
            <option value="Hispanic">Hispanic</option>
          </select>
        </div> */}

          <Box sx={{ minWidth: "49%", marginBottom: 3 }}>
  <FormControl fullWidth>
    <InputLabel
      id="gender-select-label"
      sx={{
        color: "rgba(255, 255, 255, 0.80)",
        "&.Mui-focused": {
          color: "rgba(255, 255, 255, 0.80) !important",
        },
      }}
    >
      Gender
    </InputLabel>
    <Select
      name="gender"
      labelId="gender-select-label"
      id="gender-select"
      value={formData.gender}
      label="Gender"
      onChange={(e) => setFormData({...formData, gender: e.target.value})}
      sx={{
        ...customTextFieldStylesforDropDownButton,
        "& .MuiSelect-select": {
          backgroundColor: "#282D51",
        },
        ".MuiSelect-icon": {
          color: "#ffffff",
        },
      }}
    >
      {['Man', 'Woman', 'Unspecified'].map((gender) => (
        <MenuItem
          key={gender}
          value={gender}
          sx={{
            bgcolor: "#2F355F",
            marginTop: "-8px",
            marginBottom: "-8px",
            color: "white",
            height: "56px",
            "&:hover": {
              bgcolor: "#393F69",
            },
            "&.Mui-selected": {
              bgcolor: "#393F69 !important",
            },
          }}
        >
          {gender}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Box>
        
                     <Box sx={{ minWidth: "49%", marginBottom: 3 }}>
  <FormControl fullWidth>
    <InputLabel
      id="ethnicity-select-label"
      sx={{
        color: "rgba(255, 255, 255, 0.80)",
        "&.Mui-focused": {
          color: "rgba(255, 255, 255, 0.80) !important",
        },
      }}
    >
      Ethnicity
    </InputLabel>
    <Select
      name="ethnicity"
      labelId="ethnicity-select-label"
      id="ethnicity-select"
      value={formData.ethnicity}
      label="Ethnicity"
      onChange={(e) => setFormData({...formData, ethnicity: e.target.value})}
      sx={{
        ...customTextFieldStylesforDropDownButton,
        "& .MuiSelect-select": {
          backgroundColor: "#282D51",
        },
        ".MuiSelect-icon": {
          color: "#ffffff",
        },
      }}
    >
      {[
        'White', 
        'Black', 
        'Asian American', 
        'East Asian', 
        'South East Asian', 
        'South Asian', 
        'Middle Eastern', 
        'Pacific', 
        'Hispanic', 
        'Unspecified'
      ].map((ethnicity) => (
        <MenuItem
          key={ethnicity}
          value={ethnicity}
          sx={{
            bgcolor: "#2F355F",
            marginTop: "-8px",
            marginBottom: "-8px",
            color: "white",
            height: "56px",
            "&:hover": {
              bgcolor: "#393F69",
            },
            "&.Mui-selected": {
              bgcolor: "#393F69 !important",
            },
          }}
        >
          {ethnicity}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Box>
      </div>

      {/* Appearance Row */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{
          color: '#FFF',
          fontFamily: 'Inter',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: '500',
          lineHeight: '140%',
          letterSpacing: '0.1px'
        }}>
          Appearance
        </div>
        {/* <button style={{
          color: 'var(--white, #FFF)',
          fontFamily: 'Inter',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: '400',
          lineHeight: '140%',
          letterSpacing: '0.1px',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          textDecoration: 'underline'
        }}>
          generate sample description
        </button> */}

           <Button
              onClick={() => {handleRandomDescription()}}
              sx={{
                display: "flex",
                justifyContent: "space-around",
                textTransform: "none",
                border: "1px solid rgba(255, 255, 255, 0.10)",
                padding: "8px 12px 8px 12px",
                gap: "10px",
                marginLeft: "20px",
                bgcolor: "#2F355F",
                borderRadius:"8px",
                "&:hover": { bgcolor: "#373E6D" },
                "&:active": { bgcolor: "#2F355F" },
              }}
            >
              <Box
                sx={{
                  width: "17px",
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#FFFFFF",
                }}
              >
                <DescriptionOutlinedIcon sx={{ width: "18px", height: "18px" }} />
              </Box>
              <Box
                sx={{
                  height: "20px",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontStyle: "normal",
                    fontSize: "14px",
                    fontWeight: 400,
                    lineHeight: "20px",
                    color: "#FFFFFF",
                  }}
                >
                  Generate sample description
                </Typography>
              </Box>
            </Button>
 
      </div>

      {/* Description Input */}
      <div>
        {/* <textarea
          name="description"
          placeholder="Describe your avatar. eg. A middle aged professional man in a high-rise office"
          value={formData.description}
          onChange={handleInputChange}
          style={{
            display: 'flex',
            width: '100%',
            padding: '12px 16px',
            alignItems: 'flex-start',
            flex: '1 0 0',
            alignSelf: 'stretch',
            borderRadius: '4px 4px 0px 0px',
            background: 'rgba(255, 255, 255, 0.1)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            color: 'white',
            fontSize: '14px',
            minHeight: '100px',
            resize: 'vertical'
          }}
        /> */}

          <TextField fullWidth
            type="text"
            name="description"
            label="Avatar description"
            placeholder="Describe your avatar. eg. A middle aged professional man in a high-rise office"
            value={formData.description}
            onChange={handleInputChange}
            sx={customTextFieldStylesForInvalid()}
            multiline
            style={{
                      width: "100%",
                      maxWidth: "100%",
                      height: "112px",
                      color: "#FFFFFF",
                      backgroundColor: "#232746",
                      borderRadius: "8px",
                      boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                      placeholderfontsize: "16px",
                    }}
                    InputProps={{
                      style: {
                        height: "112px", // Ensures the input field fills the container height
                        padding: "20px 14px", // Adjust padding for better alignment
                        alignItems: "flex-start", // Ensures text starts from the top
                        overflow: "auto",
                      },
                    }}
                    InputLabelProps={{
                      style: {
                        whiteSpace: "normal", // Allows label text to wrap
                        // overflow: "visible", // Ensures the entire label is visible
                      },
                    }}
          />
      </div>

      {/* Orientation and Pose Row */}
      <div style={{ display: 'flex', gap: '16px' }}>
        <div style={{ flex: 1 }}>
          <div style={{
            color: '#FFF',
            fontFamily: 'Inter',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: '500',
            lineHeight: '140%',
            letterSpacing: '0.1px',
            marginBottom: '8px'
          }}>
            Orientation
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
            {['square', 'horizontal', 'vertical'].map((option) => (
               <Grid item key={option}>
              <Button  variant="outlined"
              onClick={() => setFormData({ ...formData, orientation: option })}
                key={option}
                sx={{
                  height: "36px ",
                  padding: '8px 16px',
                  borderRadius: '8px',
                  backgroundColor: formData.orientation === option ? '#3a3f69' : "#30355f",
                  border: formData.orientation === option ? "" : "1px solid rgba(255, 255, 255, 0.10)",
                  color: theme === "dark" ? "white" : "black",
                  borderColor: formData.orientation === option  ? "#cac4d0" : "transparent",
                  cursor: 'pointer',
                  fontSize: '14px',
                  "&:hover": {
                  backgroundColor:  formData.orientation === option  ? "#3a3f69" : "",
                  border:"none",
                },
                textTransform:'none'
                }}
              >
                {option}
              </Button></Grid>
            ))}
          </div>
        </div>
        <div style={{ flex: 1 }}>
          <div style={{
            color: '#FFF',
            fontFamily: 'Inter',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: '500',
            lineHeight: '140%',
            letterSpacing: '0.1px',
            marginBottom: '8px'
          }}>
            Pose
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
            {['Half body', 'Close up', 'Full body'].map((option) => (
               <Grid item key={option}>
              <Button  variant="outlined"
                key={option}
                onClick={() => setFormData({ ...formData, pose: option })}
                sx={{
                  padding: '8px 16px',
                  borderRadius: '4px',
                  background: formData.pose === option ? '#3a3f69' : '#30355f',
                  borderColor: formData.pose === option ? '#cac4d0' : 'transparent',
                  border:  formData.pose === option ? "" : "1px solid rgba(255, 255, 255, 0.10)",
                  color: 'white',
                  cursor: 'pointer',
                  fontSize: '14px',
                  maxHeight:"36px",
                  whiteSpace:"nowrap",
                  "&:hover": {
                  backgroundColor:  formData.orientation === option  ? "#3a3f69" : "",
                  border:"none"
                },
                textTransform:'none'
                }}
              >
                {option}
              </Button></Grid>
            ))}
          </div>
        </div>
      </div>

      {/* Style Dropdown */}
      <div>
        <div style={{
          color: '#FFF',
          fontFamily: 'Inter',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: '500',
          lineHeight: '140%',
          letterSpacing: '0.1px',
          marginBottom: '20px'
        }}>
          Style
        </div>
        {/* <select
          name="style"
          value={formData.style}
          onChange={handleInputChange}
          style={{
            display: 'flex',
            height: '48px',
            width: '100%',
            padding: '0px 16px',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            flex: '1 0 0',
            alignSelf: 'stretch',
            borderRadius: '4px',
            background: 'rgba(255, 255, 255, 0.1)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            color: 'white',
            fontSize: '14px'
          }}
        >
          <option value="Unspecified">Unspecified</option>
          <option value="Realistic">Realistic</option>
          <option value="Cartoon">Cartoon</option>
          <option value="Anime">Anime</option>
          <option value="3D">3D</option>
        </select> */}

          <Box sx={{ minWidth: "49%", marginBottom: 3 }}>
                        <FormControl fullWidth>
                          <InputLabel
                            id="demo-simple-select-label"
                            sx={{
                              color: "rgba(255, 255, 255, 0.80)",
                              "&.Mui-focused": {
                                color: "rgba(255, 255, 255, 0.80) !important",
                              },
                            }}
                          >
                             Avatar style
                          </InputLabel>
                          <Select name="style" onChange={(e)=>handleInputChange(e)}
                            sx={{
                              ...customTextFieldStylesforDropDownButton,
                              "& .MuiSelect-select": {
                                backgroundColor: "#282D51",
                              },
                              ".MuiSelect-icon": {
                                color: "#ffffff",
                              },
                            }}
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={formData.style}
                            label="Avatar style"
                          >
                               <MenuItem
                              sx={{
                                bgcolor: "#2F355F",
                                marginTop: "-8px",
                                marginBottom: "-8px",
                                color: "white",
                                height: "56px",
                                "&:hover": {
                                  bgcolor: "#393F69",
                                },
                                "&.Mui-selected": {
                                  bgcolor: "#393F69 !important", // Ensure selected background color stays
                                },
                              }}
                             value={"Unspecified"}
                            >
                              Unspecified
                            </MenuItem>
                            <MenuItem
                              sx={{
                                bgcolor: "#2F355F",
                                marginTop: "-8px",
                                marginBottom: "-8px",
                                color: "white",
                                height: "56px",
                                "&:hover": {
                                  bgcolor: "#393F69",
                                },
                                "&.Mui-selected": {
                                  bgcolor: "#393F69 !important", // Ensure selected background color stays
                                },
                              }}
                              value={"Realistic"}
                            >
                              Realistic
                            </MenuItem>
                            <MenuItem
                              sx={{
                                bgcolor: "#2F355F",
                                marginTop: "-8px",
                                marginBottom: "-8px",
                                color: "white",
                                height: "56px",
                                "&:hover": {
                                  bgcolor: "#393F69",
                                },
                                "&.Mui-selected": {
                                  bgcolor: "#282D51 !important", // Ensure selected background color stays
                                },
                              }}
                              value={"Pixar"}
                            >
                              Pixar
                            </MenuItem>
                            <MenuItem
                              sx={{
                                bgcolor: "#2F355F",
                                marginTop: "-8px",
                                marginBottom: "-8px",
                                color: "white",
                                height: "56px",
                                "&:hover": {
                                  bgcolor: "#393F69",
                                },
                                "&.Mui-selected": {
                                  bgcolor: "#393F69 !important", // Ensure selected background color stays
                                },
                              }}
                              value={"Cinematic"}
                            >
                              Cinematic
                            </MenuItem>
                             <MenuItem
                              sx={{
                                bgcolor: "#2F355F",
                                marginTop: "-8px",
                                marginBottom: "-8px",
                                color: "white",
                                height: "56px",
                                "&:hover": {
                                  bgcolor: "#393F69",
                                },
                                "&.Mui-selected": {
                                  bgcolor: "#393F69 !important", // Ensure selected background color stays
                                },
                              }}
                              value={"Vintage"}
                            >
                              Vintage
                            </MenuItem>
                            <MenuItem
                              sx={{
                                bgcolor: "#2F355F",
                                marginTop: "-8px",
                                marginBottom: "-8px",
                                color: "white",
                                height: "56px",
                                "&:hover": {
                                  bgcolor: "#393F69",
                                },
                                "&.Mui-selected": {
                                  bgcolor: "#393F69 !important", // Ensure selected background color stays
                                },
                              }}
                              value={"Noir"}
                            >
                              Noir
                            </MenuItem>
                            <MenuItem
                              sx={{
                                bgcolor: "#2F355F",
                                marginTop: "-8px",
                                marginBottom: "-8px",
                                color: "white",
                                height: "56px",
                                "&:hover": {
                                  bgcolor: "#393F69",
                                },
                                "&.Mui-selected": {
                                  bgcolor: "#393F69 !important", // Ensure selected background color stays
                                },
                              }}
                              value={"Cyberpunk"}
                            >
                              Cyberpunk
                            </MenuItem>
                          </Select>
                        </FormControl>
                  </Box>
      </div>

      {/* Footer Buttons */}
      {/* <div style={{ 
        display: 'flex', 
        justifyContent: 'flex-end', 
        gap: '16px', 
        marginTop: '24px'
      }}>
        <button
          onClick={onClose}
          style={{
            padding: '12px 24px',
            borderRadius: '8px',
            background: 'transparent',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            color: 'white',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500'
          }}
        >
          Close
        </button>
        <button
  onClick={handleGeneratePreview}
  disabled={isGenerating || !formData.name || !formData.age || !formData.description}
  style={{
    padding: '12px 24px',
    borderRadius: '8px',
    background: (!isGenerating && formData.name && formData.age && formData.description) 
      ? button_bg_color_for_New_Project 
      : 'rgba(230, 224, 233, 0.12)',
    border: 'none',
    color: (!isGenerating && formData.name && formData.age && formData.description)
      ? "#17182C"
      : '#E6E0E9',
    opacity: (!isGenerating && formData.name && formData.age && formData.description) 
      ? 1 
      : 0.38,
    cursor: (!isGenerating && formData.name && formData.age && formData.description)
      ? 'pointer'
      : 'not-allowed',
    fontSize: '14px',
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  }}
>
  {isGenerating ? (
    <>
      <div style={{
        width: '16px',
        height: '16px',
        border: '2px solid rgba(255, 255, 255, 0.2)',
        borderTop: '2px solid #17182C',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }}></div>
      Generating...
    </>
  ) : (
    'Generate Preview'
  )}
</button>
      </div> */}
    </div>
  );

  const renderLoadingView = () => (
    <div style={{
      display: 'flex',
      // flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      gap: '24px'
    }}>
      {/* <div style={{
        width: '50px',
        height: '50px',
        border: '5px solid rgba(255, 255, 255, 0.2)',
        borderTop: '5px solid #4F46E5',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }}></div>
      <img src={} alt="loadingImage"/>
      <div style={{
        color: '#FFF',
        fontFamily: 'Inter',
        fontSize: '16px',
        fontWeight: '600'
      }}>
        Generating your avatar...
      </div> */}
      <Box sx={{width: '100%', height:"100%", border: "", padding:"0px" }}>
        <CommanLoaderForAvatarGeneration value={40} />
      </Box>
    </div> 
  );

  const renderPreviewView = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      {/* Title with back button */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <button 
          onClick={() => setCurrentView('main')}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'white',
            cursor: 'pointer'
          }}
        >
          <FaArrowLeft />
        </button>
        <div style={{
          color: '#FFF',
          fontFamily: 'Inter',
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: '600',
          lineHeight: '20px'
        }}>
          Pick a photo for your avatar
        </div>
      </div>

      {/* Image grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '16px',
        marginTop: '16px'
      }}>
        {previewImages.map((image) => (
          <div 
            key={image.id}
            style={{
              position: 'relative',
              width: '166px',
              height: '220px',
              flexShrink: 0,
              aspectRatio: '83/110',
              borderRadius: '16px',
              background: `url(${image.url}) lightgray 50% / cover no-repeat`,
              border: selectedImage === image.id ? '3px solid #CAC4D0' : 'none',
              cursor: 'pointer'
            }}
            onClick={() => setSelectedImage(image.id)}
          >
            {selectedImage === image.id && (
              <div style={{
                position: 'absolute',
                top: '8px',
                left: '8px',
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                background: '#4F46E5',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <FaCheck size={12} color="white" />
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Action buttons */}
      <div style={{ display: 'flex', justifyContent:"center", alignItems:"center" , gap: '16px', marginTop: '24px' }}>
        <Button sx={{
          display: 'flex',
          width: '180px',
          padding: '8px 12px',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '10px',
          borderRadius: '8px',
          background: '#282D51',
          border: 'none',
          color: 'white',
          cursor: 'pointer',
          maxHeight:"36px",
          fontFamily:"Inter",
          fontSize:"14px",
          fontStyle:"normal",
          fontWeight:400,
          lineHeight:"140%",
          letterSpacing:"0.1px",
          "&:hover": { bgcolor: "#373E6D" },
          }}
          onClick={() => setCurrentView('main')}
          >
          <FaPen size={14} />
          <span>Edit prompt</span>
        </Button>
        <Button sx={{
          display: 'flex',
          width: 'auto',
          padding: '8px 12px',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '10px',
          borderRadius: '8px',
          background: '#282D51',
          border: 'none',
          color: 'white',
          cursor: 'pointer',
          maxHeight:"36px",
          fontFamily:"Inter",
          fontSize:"14px",
          fontStyle:"normal",
          fontWeight:400,
          lineHeight:"140%",
          letterSpacing:"0.1px",
          "&:hover": { bgcolor: "#373E6D" },
        }}
        onClick={() => handleGeneratePreview()}
        >
          <FaRedo size={14} />
          <span style={{display:"flex", wordWrap:"normal"}}>Regenerate avatar</span>
        </Button>
      </div>

      {/* Footer buttons */}
      {/* <div style={{ 
        display: 'flex', 
        justifyContent: 'flex-end', 
        gap: '16px', 
        marginTop: '24px'
      }}>
        <button
          onClick={onClose}
          style={{
            padding: '12px 24px',
            borderRadius: '8px',
            background: 'transparent',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            color: 'white',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500'
          }}
        >
          Close
        </button>
        <button
  onClick={handleSaveAvatar}
  disabled={!selectedImage || isSaving}
  style={{
    padding: '12px 24px',
    borderRadius: '8px',
    background: selectedImage ? button_bg_color_for_New_Project : 'rgba(230, 224, 233, 0.12)',
    border: 'none',
    color: selectedImage ? "#17182C" : '#E6E0E9',
    opacity: selectedImage ? 1 : 0.38,
    cursor: selectedImage ? 'pointer' : 'not-allowed',
    fontSize: '14px',
    fontWeight: '500'
  }}
>
  {isSaving ? 'Saving...' : 'Save'}
</button>
      </div> */}
    </div>
  );

  const renderPromptsView = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', maxHeight:"auto"}}>
      {/* Title with back button */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <button 
          onClick={() => setCurrentView('main')}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'white',
            cursor: 'pointer'
          }}
        >
          <FaArrowLeft />
        </button>
        <div style={{
          color: '#FFF',
          fontFamily: 'Inter',
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: '600',
          lineHeight: '20px'
        }}>
          Select a look
        </div>
      </div>

      {/* Prompt grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        gap: '16px',
        marginTop: '16px'
      }}>
        {promptExamples2.map((prompt) => (
          <div 
            key={prompt.id}
            style={{
              position: 'relative',
              width: '127px',
              height: '168px',
              flexShrink: 0,
              aspectRatio: '127/168',
              borderRadius: '16px',
              background: `url(${prompt.url}) lightgray 50% / cover no-repeat`,
              border: selectedPrompt?.id === prompt.id ? '3px solid #CAC4D0' : 'none',
              cursor: 'pointer'
            }}
            onClick={() => setSelectedPrompt(prompt)}
          >
            {selectedPrompt?.id === prompt.id && (
              <div style={{
                position: 'absolute',
                top: '8px',
                left: '8px',
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                background: '#4F46E5',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <FaCheck size={12} color="white" />
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Footer buttons */}
      {/* <div style={{ 
        display: 'flex', 
        justifyContent: 'flex-end', 
        gap: '16px', 
        marginTop: '24px'
      }}>
        <button
          onClick={() => setCurrentView('main')}
          style={{
            padding: '12px 24px',
            borderRadius: '8px',
            background: 'transparent',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            color: 'white',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500'
          }}
        >
          Close
        </button>
        <button
          onClick={() => handleUsePrompt(selectedPrompt)}
          disabled={!selectedPrompt}
          style={{
            padding: '12px 24px',
            borderRadius: '8px',
            background: selectedPrompt ? button_bg_color_for_New_Project : 'rgba(230, 224, 233, 0.12)',
            border: 'none',
            color: selectedPrompt ? "#17182C"  :  '#E6E0E9',
            opacity: selectedPrompt ? 1 : 0.38,
            cursor: selectedPrompt ? 'pointer' : 'not-allowed',
            fontSize: '14px',
            fontWeight: '500'
          }}
        >
          Use Prompt
        </button>
      </div> */}
    </div>
  );

  return (
    <div style={{
    maxWidth: '750px',
    maxHeight: '90%',
    flexShrink: 0,
    borderRadius: '16px',
    border: '1px solid rgba(255, 255, 255, 0.10)',
    background: '#1F233E',
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width:"750px"
    // height: '100%' // Ensure the container takes full height
  }}>
    {/* Modal Header - Fixed at top */}
    <div style={{
      display: 'flex',
      width: '100%',
      padding: '20px',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid rgba(255, 255, 255, 0.10)',
      flexShrink: 0 // Prevent header from shrinking
    }}>
      <div style={{
        color: '#FFF',
        textAlign: 'center',
        fontFamily: 'Inter',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: '20px'
      }}>
        Create your AI avatar
      </div>
      <button 
        onClick={onClose}
        style={{
          background: 'transparent',
          border: 'none',
          color: 'white',
          cursor: 'pointer',
          fontSize: '20px'
        }}
      >
        <FaTimes />
      </button>
    </div>

    {/* Scrollable Content Area */}
    <div style={{
      flex: 1, // Take up remaining space
      height:"auto",
      overflowY:  currentView !== 'loading' &&  'auto',
      padding: currentView !== 'loading' &&  '20px'
    }}>
      {currentView === 'main' && renderMainView(true)}
      {currentView === 'loading' && renderLoadingView()}
      {currentView === 'preview' && renderPreviewView(true)}
      {currentView === 'prompts' && renderPromptsView(true)}
    </div>

    {/* Fixed Footer */}
    <div style={{ 
      padding: currentView !== 'loading' && '20px',
      borderTop: '1px solid rgba(255, 255, 255, 0.10)',
      flexShrink: 0 // Prevent footer from shrinking
    }}>
      {currentView === 'main' && (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'flex-end', 
          gap: '16px'
        }}>
          <button
            onClick={onClose}
            style={{
              padding: '12px 24px',
              borderRadius: '8px',
              background: 'transparent',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              color: 'white',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            Close
          </button>
          <button
            onClick={handleGeneratePreview}
            disabled={isGenerating || !formData.name || !formData.age || !formData.description}
            style={{
              padding: '12px 24px',
              borderRadius: '8px',
              background: (!isGenerating && formData.name && formData.age && formData.description) 
                ? button_bg_color_for_New_Project 
                : 'rgba(230, 224, 233, 0.12)',
              border: 'none',
              color: (!isGenerating && formData.name && formData.age && formData.description)
                ? "#17182C"
                : '#E6E0E9',
              opacity: (!isGenerating && formData.name && formData.age && formData.description) 
                ? 1 
                : 0.38,
              cursor: (!isGenerating && formData.name && formData.age && formData.description)
                ? 'pointer'
                : 'not-allowed',
              fontSize: '14px',
              fontWeight: '500',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}
          >
            {isGenerating ? (
              <>
                <div style={{
                  width: '16px',
                  height: '16px',
                  border: '2px solid rgba(255, 255, 255, 0.2)',
                  borderTop: '2px solid #17182C',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite'
                }}></div>
                Generating...
              </>
            ) : (
              'Generate Preview'
            )}
          </button>
        </div>
      )}
      {currentView === 'loading' && (
        null
      )}
      {currentView === 'preview' && (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'flex-end', 
          gap: '16px'
        }}>
          <button
            onClick={onClose}
            style={{
              padding: '12px 24px',
              borderRadius: '8px',
              background: 'transparent',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              color: 'white',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            Close
          </button>
          <button
            onClick={handleSaveAvatar}
            disabled={!selectedImage || isSaving}
            style={{
              padding: '12px 24px',
              borderRadius: '8px',
              background: selectedImage ? button_bg_color_for_New_Project : 'rgba(230, 224, 233, 0.12)',
              border: 'none',
              color: selectedImage ? "#17182C" : '#E6E0E9',
              opacity: selectedImage ? 1 : 0.38,
              cursor: selectedImage ? 'pointer' : 'not-allowed',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            {isSaving ? 'Saving...' : 'Save'}
          </button>
        </div>
      )}
      {currentView === 'prompts' && (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'flex-end', 
          gap: '16px'
        }}>
          <button
            onClick={() => setCurrentView('main')}
            style={{
              padding: '12px 24px',
              borderRadius: '8px',
              background: 'transparent',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              color: 'white',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            Close
          </button>
          <button
            onClick={() => handleUsePrompt(selectedPrompt)}
            disabled={!selectedPrompt}
            style={{
              padding: '12px 24px',
              borderRadius: '88px',
              background: selectedPrompt ? button_bg_color_for_New_Project : 'rgba(230, 224, 233, 0.12)',
              border: 'none',
              color: selectedPrompt ? "#17182C"  :  '#E6E0E9',
              opacity: selectedPrompt ? 1 : 0.38,
              cursor: selectedPrompt ? 'pointer' : 'not-allowed',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            Use Prompt
          </button>
        </div>
      )}
    </div>
  </div>
  );
};

export default CreateAvatarFromScript;